import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@siat-fe/env';
import { Observable } from 'rxjs';
import {
  AnagraficaAPSSResponse,
  AnagraficaSearchDTO,
  PatientDTO,
} from './search-patient.model';

@Injectable({
  providedIn: 'root',
})
export class SearchPatientService {
  private readonly apiUrl = `${environment.baseUrl}v1/anagrafica`;
  private readonly baseApiUrl = `${environment.baseUrl}`;

  private http = inject(HttpClient);

  getAllPatient(): Observable<PatientDTO[]> {
    return this.http.get<PatientDTO[]>(this.apiUrl);
  }

  getPatientById(id: number): Observable<PatientDTO> {
    return this.http.get<PatientDTO>(`${this.apiUrl}/${id}`);
  }

  findFromAPSS(
    payload: AnagraficaSearchDTO
  ): Observable<AnagraficaAPSSResponse> {
    return this.http.post<AnagraficaAPSSResponse>(
      `${this.baseApiUrl}v1/anagrafica/findFromAPSS`,
      payload
    );
  }

  fetchAddPatient(patient: PatientDTO): Observable<PatientDTO> {
    return this.http.post<PatientDTO>(`${this.apiUrl}`, patient);
  }

  fetchUpdatePatient(patient: PatientDTO): Observable<PatientDTO> {
    return this.http.put<PatientDTO>(`${this.apiUrl}`, patient);
  }
}
